import { render, staticRenderFns } from "./location-view.vue?vue&type=template&id=105b3ef0&scoped=true"
import script from "./location-view.vue?vue&type=script&lang=js"
export * from "./location-view.vue?vue&type=script&lang=js"
import style0 from "./location-view.vue?vue&type=style&index=0&id=105b3ef0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105b3ef0",
  null
  
)

export default component.exports